module.exports = __webpack_public_path__ + "img/labmem_text_share_en.a95cb763.png";